<template>
<layout-content>
  <template #toolbar>
    <el-date-picker
      v-model="beginTime"
      size="small"
      type="year"
      value-format="yyyy"
      :clearable="false"
      :editable="false"
      @change="yearChange"
      style="width: 100px;"
      :picker-options="startDatePickerOptions"
    >
    </el-date-picker>
    <span>～</span>
    <el-date-picker
      v-model="endTime"
      size="small"
      type="year"
      value-format="yyyy"
      :clearable="false"
      @change="yearChange"
      style="width: 100px;"
      :picker-options="endDatePickerOptions"
    >
    </el-date-picker>

    <el-select v-model="query.siteIds[0]" size="small" style="width: 150px;">
      <el-option
        v-for="item in filterSites"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>

    <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <div :style="`width: 100%;height: ${years.length * 232 + 110}px;padding: 5px 10px;`">
      <air-quality-calendar-chart
        ref="charts"
        :data="chartDatas"
      />
    </div>
  </template>
</layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import AirQualityCalendarChart from '../../../../components/Data/AirQualityCalendarChart'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

export default {
  name: 'StatisticalAnalysisAirQualityCalendar',
  routeInfo: {
    label: '空气质量年历'
  },
  extends: BaseFactorData,
  components: {AirQualityCalendarChart},
  data () {
    let beginTime = new Date()
    beginTime.setDate(beginTime.getDate() - 365)
    let endTime = new Date()
    endTime.setDate(endTime.getDate() - 1)
    return {
      beginTime: beginTime.format('YYYY/01/01 00:00:00'),
      endTime: endTime.format('YYYY/12/31 23:59:59'),
      query: {
        beginTime: beginTime.format('YYYY/01/01 00:00:00'),
        endTime: endTime.format('YYYY/12/31 23:59:59'),
        factorIds: [1001, 1003, 1005, 1006, 1007, 1008],
        granularity: 24,
        isSiteMerge: false,
        isTimeMerge: false,
        isAuditCompleted: false
      },
      data: [],
      years: [],
      chartDatas: []
    }
  },
  computed: {
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.beginTime)
      }
    },
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    minSiteSelectNumber: () => 1,
    completeAllData: () => false,
    valueProp: () => 'value',
    _siteDeviceCategoryConfig () {
      let bit = 0
      return this.siteDeviceCategoryConfig.reduce((map, deviceCategoryConfig) => {
        let {categoryId} = deviceCategoryConfig
        let num = 1 << bit

        if (!map.map[categoryId]) {
          map.map[categoryId] = {
            bit: bit,
            filter: deviceCategoryConfig.filter
          }
          map.total |= num
          map.min |= num & (-deviceCategoryConfig.required)
          bit++
        }

        return map
      }, {
        map: {},
        total: 0,
        min: 0
      })
    },
    _filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {_siteDeviceCategoryConfig: {map: deviceCategoryMap, total, min}, profileSiteMap} = this

      return Object.values(profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        let deviceCategoryConfig = deviceCategoryMap[siteDevice.categoryId]

        if (deviceCategoryConfig) {
          let {filter} = deviceCategoryConfig
          let siteDeviceFactors = filter instanceof Function
            ? filter(siteDevice.siteDeviceFactors)
            : [...siteDevice.siteDeviceFactors]

          if (siteDeviceFactors.length > 0) {
            let {bit} = deviceCategoryConfig
            let tmpSite = map[siteId]

            if (!tmpSite) {
              tmpSite = map[siteId] = {
                id: siteId,
                name: site.name,
                total: 0,
                devices: []
              }
            }

            tmpSite.total |= 1 << bit
            tmpSite.devices.push({
              ...siteDevice,
              siteDeviceFactors
            })
          }
        }

        return map
      }, {})).filter(site => (site.total & total) >= min)
    },
    filterSites () {
      return this._filterSites
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    isNoSelectedSites () {
      return this.query.siteIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites
    }
  },
  methods: {
    onAuditCompletedChanged () {
      this.afterSetSiteIds()
    },
    yearChange () {
      let {beginTime, endTime} = this
      this.query.beginTime = new Date(beginTime).format('YYYY/01/01 00:00:00')
      this.query.endTime = new Date(endTime).format('YYYY/12/31 23:59:59')
    },
    renderData () {
      setTimeout(() => {
        let dataRenders = this.getDataRenders()

        if (dataRenders) {
          dataRenders.forEach(dataRender => dataRender.render())
        }
      }, 0)
    },
    getDataRenders () {
      return Array.isArray(this.$refs['charts']) ? this.$refs['charts'] : [this.$refs['charts']]
    },
    setQuery (query) {
      let {beginTime, endTime} = query
      delete query.dataType
      let beginYear = new Date(beginTime).getFullYear()
      let endYear = new Date(endTime).getFullYear()
      let years = []
      if (beginYear === endYear) {
        years.push(beginYear)
      } else {
        for (let i = 0; i <= endYear - beginYear; i++) {
          years.push(beginYear + i)
        }
      }

      return {
        ...query,
        years: years
      }
    },
    getData () {
      this.changeLoadStatus(true)
      let query = this.setQuery(JSON.parse(JSON.stringify(this.query)))
      this.years = query.years

      if (query.siteIds.length === 0) {
        this.changeLoadStatus(false)
        return false
      }
      this.$api.Aqi.getAQIData(query).then(backData => {
        this.formatData(backData)
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData (data) {
      let {query: {beginTime, endTime, granularity}} = this
      let beginTS = new Date(beginTime).getTime()
      let endTS = new Date(endTime).getTime()
      let tsStep = granularity * 60 * 60000
      let dateData = {}

      for (let ts = beginTS; ts <= endTS; ts += tsStep) {
        dateData[ts] = {
          dataTime: new Date(ts).format('YYYY-MM-DD')
        }
      }

      let chartDatas = {}
      data.forEach(el => {
        let {dataTime} = el
        let ts = new Date(dataTime).getTime()

        dateData[ts] = el
      })

      chartDatas = Object.values(dateData).reduce((map, el) => {
        if (el.primaryPollutant) {
          el.primaryPollutant = el.primaryPollutant.replace('H8O3', 'O3')
        }
        let date = new Date(el.dataTime)
        let year = date.getFullYear()
        if (!map[year]) {
          map[year] = {
            year: year,
            heatmapData: [],
            lunarData: []
          }
        }
        let temp = el.pollutantData ? el.pollutantData.find(item => item.rootFactorId === el.primaryPollutant) : {}
        let pollutantVal = el.primaryPollutant !== '无' || el.primaryPollutant ? (temp ? Number(temp.value).toFixed(2) : '--') : '--'

        map[year].lunarData.push([new Date(el.dataTime).format('YYYY-MM-DD'), el.aqi ? Number(el.aqi).toFixed(2) : null, el.primaryPollutant ? el.primaryPollutant : '--', pollutantVal])
        map[year].heatmapData.push([new Date(el.dataTime).format('YYYY-MM-DD'), el.aqi ? Number(el.aqi).toFixed(2) : null])
        return map
      }, {})

      this.chartDatas = Object.values(chartDatas)
    },
    windowRize () {
      setTimeout(() => {
        this.renderData()
      }, 0)
    }
  },
  created () {
    window.addEventListener('resize', this.windowRize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowRize)
  }
}
</script>

<style lang="scss" scoped>
.data-wrapper {
  .site-data {
    & + .site-data {
      margin-top: 20px;
    }
  }

  .site-data-header {
    line-height: 1.8em;
    padding: 0 10px;
    background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    color: #ffffff;
    font-weight: 600;
  }

  .site-data-body {
    height: 350px;
  }
}
.device-dropdown-selector-wrapper {
  display: grid;
  grid-template-rows: auto 1px max-content;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .device-dropdown-selector-wrapper-inner {
    padding: 12px;
    overflow: auto;
  }

  .device-dropdown-selector {
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/06Air-Quality-Calendar/index.vue